export default "/images/paperclip.svg?af7f585d9640a879d268b5b73b078eb2";